const makeSharableInternalLink = (
    origin: string,
    path: string,
    id: number,
): string => {
    return `${origin}${path}?_ap_pageid=${id}`;
};

export default makeSharableInternalLink;
